import type { MultiselectProps } from '@risk-smart/themed-cloudscape-components/multiselect';
import CSMultiSelect from '@risk-smart/themed-cloudscape-components/multiselect';
import { forwardRef, useMemo, useState } from 'react';

import { filterOptionsByVisibleText } from '../option-label-filter/filterOptionsByVisibleText';
import styles from './style.module.scss';

const Multiselect = forwardRef<MultiselectProps.Ref, MultiselectProps>(
  ({ filteringType = 'auto', options, onLoadItems, ...props }, ref) => {
    const [filteringText, setFilteringText] = useState('');

    // See filterOptionsByVisibleText for why we override 'auto' filtering.
    const preFilter = filteringType === 'auto';

    const visibleOptions = useMemo(
      () =>
        preFilter
          ? filterOptionsByVisibleText(options, filteringText)
          : options,
      [options, filteringText, preFilter]
    );

    return (
      <div className={styles.select}>
        <CSMultiSelect
          {...props}
          filteringType={preFilter ? 'manual' : filteringType}
          options={visibleOptions}
          onLoadItems={(event) => {
            if (preFilter) {
              setFilteringText(event.detail.filteringText ?? '');
            }
            onLoadItems?.(event);
          }}
          ref={ref}
        />
      </div>
    );
  }
);
Multiselect.displayName = 'Multiselect';

export default Multiselect;
